import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/outline';
import Image from './DistImage'
import axios from '../../axios'
const BatchDetails = () => {
  const navigate = useNavigate();
  const location=useLocation()
  const {id}=location.state||{}
  const [batch, setBatch] = useState({});
  const [image,setImage]=useState([])

  useEffect(() => {
    axios.get(`batch/get/${id}`)
      .then((res) => {
        // console.log(res.data)
        setBatch(res.data)
        const imageData=res.data.distribution_images
        const imageArray=JSON.parse(imageData)
        setImage(imageArray)
      })

      .catch((err) => console.log(err));
  }, [id]);
  // dateUtils.js
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
};

  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center">
    <div className=" flex flex-col gap-5 w-11/12">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="flex items-center justify-between bg-gray-100 p-4 border-b border-gray-400">
          <div className="flex items-center space-x-2">
            <ArrowLeftIcon
              className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-800 transition"
              onClick={() => navigate('/batches')}
            />
            <p className="text-xl font-semibold text-gray-700" > Batch/TBN No. -&nbsp;
              {batch.tbn_no}
            </p>
          </div>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {(batch.uniform_distribution=='Distributed' ||  batch.study_material_distribution=='Distributed') &&(
               <Image images={image}/> 
            )}
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Name</div>
              <div className="text-gray-600">{batch.batch_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Id/TBN No.</div>
              <div className="text-gray-600">{batch.tbn_no}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Course Code</div>
              <div className="text-gray-600">{batch.course_code}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Course Name</div>
              <div className="text-gray-600">{batch.course_name}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Sector Name</div>
              <div className="text-gray-600">{batch.sector_name}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Type</div>
              <div className="text-gray-600">{batch.batch_type  }</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Phase</div>
              <div className="text-gray-600">{batch.batch_phase}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Status</div>
              <div className="text-gray-600">{batch.status}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">TC Capacity</div>
              <div className="text-gray-600">{batch.capacity}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Size</div>
              <div className="text-gray-600">{batch.to_enrolled_no}</div>
                </div>
                
               
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Training Type</div>
              <div className="text-gray-600">{batch.training_type}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Trainer Name</div>
              <div className="text-gray-600">{batch.trainer_names}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Daily Training Duration</div>
              <div className="text-gray-600">{batch.daily_training_duration} hours</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Uniform Distributon</div>
              <div className="text-gray-600">{batch.uniform_distribution}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Study Material Distributon</div>
              <div className="text-gray-600">{batch.study_material_distribution}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Assessment Date</div>
              <div className="text-gray-600">{formatDate(batch.assesment_date)}</div>
                </div>
                <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Assessed By</div>
              <div className="text-gray-600">{batch.assest_by}</div>
                </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Start Date</div>
              <div className="text-gray-600">{formatDate(batch.start_date)}</div>
</div>
<div className="flex flex-col">
              <div className="text-gray-800 font-bold">End Date</div>
              <div className="text-gray-600">{formatDate(batch.end_date)}</div>
</div>
<div className="flex flex-col">
              <div className="text-gray-800 font-bold">OJT Start Date</div>
              <div className="text-gray-600">{formatDate(batch.ojt_start_date)}</div>
</div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">OJT End Date</div>
              <div className="text-gray-600">{formatDate(batch.ojt_end_date)}</div>
                </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default BatchDetails;
